export default __webpack_public_path__ + "static/media/Fries_proportioned_170.c755e938.jpg";